import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { LoginContext } from "./loginContext";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useContext(LoginContext);

  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // If logged in, render the protected component
  return children;
};

export default ProtectedRoute;
